import { Injectable } from '@angular/core';
import { HttpService } from '../../core/services/http/http.service';
@Injectable({
  providedIn: 'root'
})
export class OpenlinksService {

  constructor(private http: HttpService) { }

  
  getLinkByToken(token) {
    return this.http.query('get', 'link-token/'+token, {});
  }

  getuser() {
    return this.http.query('get', 'user', {} );
  }

  openLock(url) {
    return this.http.query('get', url, {});
  }

  tupas(payload) {
    return this.http.query('post', 'tupas/redirect', {}, '', payload , 'openId');
  }
 
}
